import i18n from "i18next";

export function formatOrderMoney(value, currency, language = i18n.language) {
    if (value === null || value === undefined || !Number.isFinite(Number(value))) {return "—";}
    if (!currency) {return i18n.t("OrderAmountsUnavailable") || "—";}
    try {
        return new Intl.NumberFormat(language || "en", {style: "currency", currency, minimumFractionDigits: 2, maximumFractionDigits: 2}).format(Number(value));
    } catch {return i18n.t("OrderAmountsUnavailable") || "—";}
}

export const singleOrderCurrency = products => products?.length && products.every(item => item.currency && item.currency === products[0].currency)
    ? products[0].currency : null;

export function amountExportRows(amounts, t) {
    return amounts.totals.flatMap(group => [...["requested", "confirmed", "shipped", "delivered", ...["outstanding", "cancelled"].filter(phase => group[phase])].map(phase => [
        group.currency || t("DistributorCurrencyUnavailable"), t(`OrderAmount${phase}`), group[phase].quantity ?? "—",
        group[phase].subtotal ?? "—", group[phase].shipping ?? "—", group[phase].total ?? "—",
    ]), [group.currency || t("DistributorCurrencyUnavailable"), t("OrderAmountDifference"),
        group.confirmed.quantity == null || group.requested.quantity == null ? "—" : group.confirmed.quantity - group.requested.quantity,
        ...["subtotal", "shipping", "total"].map(key => group.confirmed[key] == null || group.requested[key] == null ? "—" : Number((Number(group.confirmed[key]) - Number(group.requested[key])).toFixed(2)))]]);
}
